import React from "react";
import Login from "flow-core-components-login";

/**
 * Login module
 * @return  {*}
 * @constructor
 */
const LoginModule = () => {
    return <Login />;
};

export default LoginModule;
